import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./rules.component.html?ngResource";
import { Component, ViewChild, } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import _ from 'lodash';
import { RulesService } from './rules.service';
import { FormSchemas } from '../dynamic-forms/form-schemas';
import newRuleTemplate from './new-rule-template';
import { NgxSmartModalService } from 'ngx-smart-modal';
import OrganizationService from '../../../core/services/organization.service';
import { MessageService } from 'primeng/api';
let RulesComponent = class RulesComponent {
    rulesService;
    ngxSmartModalService;
    organizationService;
    messageService;
    #destroy$ = new Subject();
    rules = [];
    actions = [];
    selected = null;
    cols;
    formOptions = {};
    stackStormToFormMap = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    model = {}; // used to convert StackStorm data to FormIO
    currentFormType = '';
    newRuleMode;
    newRuleModel;
    newRuleFormOptions = {
        formType: '',
        hideAdvanced: false
    };
    formValid = false;
    organizations; // OrganizationService not converted to typescript yet
    filteredRules = [];
    selectedOrg = 'all';
    ruleForm;
    constructor(rulesService, ngxSmartModalService, organizationService, messageService) {
        this.rulesService = rulesService;
        this.ngxSmartModalService = ngxSmartModalService;
        this.organizationService = organizationService;
        this.messageService = messageService;
        this.cols = [{ field: 'name', header: 'header', width: 200 }];
        this.newRuleMode = false;
    }
    async ngOnInit() {
        this.getRules();
        this.getActions();
        this.organizations = await this.organizationService.model;
    }
    getRules(selectRule) {
        this.rulesService.getRules()
            .pipe(takeUntil(this.#destroy$))
            .subscribe((response) => {
            this.rules = response.data;
            this.orgChange();
            if (selectRule) {
                this.manualSelectRow(this.findRule(selectRule));
            }
        });
    }
    getActions() {
        this.rulesService.getActions('st2_t20')
            .pipe(takeUntil(this.#destroy$))
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .subscribe((response) => {
            this.actions = response.data;
            this.stackStormToFormMap = _.transform(this.actions, (memo, action) => {
                const ref = action.ref;
                const form = _.replace(ref, 'st2_t20.', '');
                memo[ref] = form;
            });
        });
    }
    onRowSelect(event) {
        if (this.ruleForm) {
            this.ruleForm.destroyForm();
        }
        this.newRuleMode = false;
        this.newRuleModel = undefined;
        const ref = event.data.action.ref;
        const formType = this.stackStormToFormMap[ref];
        this.formOptions = {
            formType: formType || 'rawjson',
            hideAdvanced: true,
            doNotExtendFormWithModel: true
        };
        const rule = event.data;
        const formModalStructure = FormSchemas.getFormModelStructure(formType);
        // Converts StackStorm data structure to FormIO structure
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.model = _.transform(formModalStructure, (result, path, key) => {
            if (path.dataType === 'grid') {
                _.set(result, key, []);
                _.forOwn(rule[path.basePath], (possibleDataGridRow) => {
                    const modelVariable = possibleDataGridRow?.dataGrid ? JSON.parse(possibleDataGridRow.dataGrid).model : false;
                    if (modelVariable && modelVariable === key) {
                        if (possibleDataGridRow.type === 'search') {
                            // split
                            const splitDataGridRow = _.reduce(possibleDataGridRow.pattern, (memo, pattern, patternKey) => {
                                const realKey = patternKey.split('#', 1)[0];
                                if (!memo[realKey]) {
                                    memo[realKey] = {
                                        type: possibleDataGridRow.type,
                                        condition: possibleDataGridRow.condition,
                                        eventData: pattern.eventData,
                                        minPatternObj: pattern.minPatternObj,
                                        maxPatternObj: pattern.maxPatternObj,
                                        pattern: {
                                            [patternKey]: {
                                                type: pattern.type,
                                                pattern: pattern.pattern
                                            }
                                        }
                                    };
                                }
                                memo[realKey].pattern[patternKey] = pattern;
                                return memo;
                            }, {});
                            _.forEach(splitDataGridRow, (row) => {
                                result[key].push(row);
                            });
                        }
                        else {
                            result[key].push(possibleDataGridRow);
                        }
                    }
                });
            }
            else if (path.dataType === 'custom') {
                _.set(result, key, path.func(_.get(rule, path.path)));
            }
            else {
                _.set(result, key, _.get(rule, path));
            }
        });
        this.selected = _.cloneDeep(rule);
        this.currentFormType = formType;
    }
    saveRule() {
        this._resetSelected();
        const formModalStructure = FormSchemas.getFormModelStructure(this.currentFormType);
        _.forEach(formModalStructure, (path, key) => {
            if (path.doNotSave || this.model[key] === '') {
                return;
            }
            if (path.dataType === 'grid') {
                const multiSelectCount = {};
                _.forEach(this.model[key], (dataGridRow) => {
                    try {
                        const parseDataGrid = JSON.parse(dataGridRow.dataGrid);
                        const dataGridPath = parseDataGrid.path;
                        const selectedPath = dataGridPath;
                        const selectedExists = _.get(this.selected, dataGridPath);
                        // add #N to the end to avoid duplicate keys, unless it's a search
                        if (selectedExists && !parseDataGrid.search) {
                            const endOfSelectedPath = selectedPath.pop();
                            multiSelectCount[endOfSelectedPath] = multiSelectCount[endOfSelectedPath] + 1 || 2;
                            selectedPath.push(`${endOfSelectedPath}#${multiSelectCount[endOfSelectedPath]}`);
                        }
                        _.set(this.selected, selectedPath, _.merge(_.get(this.selected, selectedPath), dataGridRow));
                    }
                    catch (exception) {
                        if (!(exception instanceof SyntaxError)) {
                            throw exception;
                        }
                    }
                });
            }
            else if (path.dataType === 'custom') {
                _.set(this.selected, path.path, this.model[key]);
            }
            else {
                _.set(this.selected, path, this.model[key]);
            }
        });
        if (this.newRuleMode) {
            this.selected.pack = this.newRuleModel.pack;
            this.rulesService.createRule(this.selected)
                .pipe(takeUntil(this.#destroy$))
                .subscribe({
                next: (response) => {
                    this._toastMessage('success', 'Saved', `Saved ${this.selected.name}`);
                    this.getRules(response.data);
                },
                error: (error) => {
                    console.error(error);
                    this._toastMessage('error', 'Error Saving', error?.data?.error || JSON.stringify(error));
                }
            });
        }
        else {
            this.rulesService.setRule(this.selected)
                .pipe(takeUntil(this.#destroy$))
                .subscribe({
                next: (response) => {
                    this._toastMessage('success', 'Updated', `Updated ${this.selected.name}`);
                    this.getRules(response.data);
                },
                error: (error) => {
                    console.error(error);
                    this._toastMessage('error', 'Error Updating', error?.data?.error || JSON.stringify(error));
                }
            });
        }
    }
    deleteRule() {
        this.ngxSmartModalService.open('deleteRuleModal');
    }
    confirmDeleteRule() {
        this.rulesService.deleteRule(this.selected.id)
            .pipe(takeUntil(this.#destroy$))
            .subscribe(() => {
            this.selected = null;
            this.getRules();
        });
        this.ngxSmartModalService.close('deleteRuleModal');
    }
    modelChange(update) {
        if (update.id === this.selected.id) {
            _.forEach(this.model, (_val, key) => {
                delete this.model[key];
            });
            _.assign(this.model, update.model);
        }
    }
    newRule() {
        this.selected = {};
        this.newRuleMode = true;
        this.newRuleModel = undefined;
        this.newRuleFormOptions = {
            formType: 'select rule',
            hideAdvanced: true
        };
    }
    newRuleModelChange({ model }) {
        this.newRuleModel = model;
        this.currentFormType = model.action;
        const formModalStructure = FormSchemas.getFormModelStructure(model.action);
        this.model = {};
        this.formOptions = {
            formType: model.action,
            title: 'Create New',
            hideAdvanced: true,
            doNotExtendFormWithModel: true
        };
        this.selected = _.cloneDeep(newRuleTemplate);
        _.forEach(formModalStructure, (path, key) => {
            _.set(this.selected, path, this.model[key]);
        });
        this.selected.action.ref = `st2_t20.${model.action}`;
    }
    findRule({ id }) {
        return _.find(this.rules, ['id', id]);
    }
    manualSelectRow(event) {
        this.onRowSelect({ data: event });
    }
    onFormFeedback(event) {
        this.formValid = event?.type === 'isValid' && event?.data;
    }
    orgChange() {
        if (this.selectedOrg === 'all') {
            this.filteredRules = _.cloneDeep(this.rules);
        }
        else if (this.selectedOrg === 'unassigned') {
            this._filterOrg(true);
        }
        else {
            this._filterOrg();
        }
    }
    _filterOrg(unassigned) {
        this.filteredRules = _.filter(this.rules, rule => unassigned ? !rule?.type?.parameters?.org :
            rule?.type?.parameters?.org === this.selectedOrg);
    }
    _toastMessage(severity, summary, detail) {
        this.messageService.add({
            severity,
            summary,
            detail,
        });
    }
    _resetSelected() {
        this.selected.criteria = {};
    }
    static ctorParameters = () => [
        { type: RulesService },
        { type: NgxSmartModalService },
        { type: OrganizationService },
        { type: MessageService }
    ];
    static propDecorators = {
        ruleForm: [{ type: ViewChild, args: ['ruleForm',] }]
    };
};
RulesComponent = __decorate([
    Component({
        selector: 'rules',
        template: __NG_CLI_RESOURCE__0,
        providers: [MessageService],
    })
], RulesComponent);
export { RulesComponent };
